//Copyright © Northstar Travel Media, LLC. All Rights Reserved - code may not be reused in whole or in part without written consent- removal of this section consitutes a copyright violation
var mapStyle = [{ "featureType": "landscape", "elementType": "geometry.fill", "stylers": [{ "hue": "#54ff00" }] }, { "featureType": "water", "elementType": "geometry.fill", "stylers": [{ "color": "#7aaec2" }] }];

function rotateads(){} //do nothing
   
function myrnd() { return Math.round(Math.random() * 10000000000) }
function appndURL(u, a) { if (u.indexOf('?') == -1) { u = u + '?' } else { u = u + '&' }; u = u + a; return u }
function donothing() { }
function disablelink(a) { a.disabled = true; a.onclick = dontdo; a.href = '' }
function enablelink(a, href) { a.disabled = false; a.onclick = ''; a.href = href; }
function dontdo() { return false }
function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
//do this to get referer on window.location calls
function winloc(u) { window.location = u }
function refreshwin(c) {
     if (c == undefined) { c = true }
     var u = window.location.href.split('#')[0]
     if (c) { u = window.location.pathname }
     var n = new String(u).length
     var l = new String(u).substring(n-1, n+1)
     if (l.toString() == "#") {u = new String(u).substring(0, n - 1)}
     window.location = u
 }

 function refreshWithQueryParam(paramName, paramValue) {
    // Get the current URL
    const url = new URL(window.location.href);

    // Remove the parameter if it already exists
    url.searchParams.delete(paramName);

    // Add the new parameter
    url.searchParams.append(paramName, paramValue);

    // Refresh the page with the updated URL
    window.location.href = url.toString();
}


function _newopt(t, v, s) { var optn = document.createElement("OPTION"); optn.text = t; optn.value = v; optn.selected = v == s; return optn }
function _newopthtml(t, v, s) { return '<option value="' + v + '"' + (v == s ? " selected" : "") + '>' + t + '</option>' }
function showError(error) { var stackTrace = error.get_stackTrace(); var message = error.get_message(); var statusCode = error.get_statusCode(); var exceptionType = error.get_exceptionType(); var timedout = error.get_timedOut(); console.log("-" + message + "-"); if (message == "error 0") { return; } alert(message); }

function serviceProxy(serviceUrl) {
    var _I = this;
    this.serviceUrl = serviceUrl;
    this.invoke = function(method, data, callback, error) {
        var json = JSON.stringify(data);
        var url = _I.serviceUrl + method;
        $.ajax({
            url: url,
            data: json,
            type: "POST",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function(data) {
                if (data.d) { data = data.d }
                if (!callback) return; callback(data); return;
            },
            error: function(err) { if (!error) return; error(err); return; }
        });
     }
 }
function AjaxFailed(result) { if (result.status == 0) { return; } alert(result.status + ' ' + result.statusText); }

DynaProxy = new serviceProxy("/Dyna.asmx/");

function hasGA() { return !(typeof _qaq === 'undefined') }

// **************  START PAGE TRACKING ********************************************************  
function myTrackPageView(u,r,a){
    if (a == undefined) { a = "" }
    var orgu = u; qs = ""; qs2 = "";
    if (u.indexOf('?') != -1) { qs = u.substring(u.indexOf('?') + 1); qs2 = "?" + qs }
    try { initTracking(); u = s.prop1 + "/AJAX/" + a; } catch (e) { };
    try { pageTracker._trackPageview(u + qs2); } catch (e) { };
    try { s.prop70 = a; s.prop1 = u; s.prop2 = qs; s.t(); } catch (e) { };
    if (r) { window.setTimeout(rotateads, 1000) }


}
function myTrackEvent(category, action, label, value) {
    try {
        if (ga) { ga('send', 'event', 'Ajax Actions', category, action); }
    } catch (e) { }

}
// **************  END PAGE TRACKING ********************************************************



// **************  GUI ELEMENTS ********************************************************
function hidewait() {
   // new overlayModuleTrips().hideOverlay()
}

function showWait(msg){
    if (!msg){msg='Applying Changes'}
    //new overlayModuleTrips().showOverlay("/widgets/Wait?s=" + escape(msg),false)
}
// **************  GUI ELEMENTS ********************************************************  



// **************  START AJAX POPUP ********************************************************  
var bLastX=-1
function OnAJAXPopDataSucceeded(r, typ){if (r!=''){showdetail(r,typ)}}
function closePAj2(e){window.setTimeout(closePAj,25)}//if this is done to quickly on click, it causes an error
function closePAjRef(e){window.location=window.location;  }
function closePAj() {
    //new overlayModuleTrips().hideOverlay()
    hideModal('aj')
 }
 function closeAj() {
     b = $find('popBhvAj'); if (b) { b.hidePopup() }
}
function rAJAXPop(u,typ,arg,e){_cnEvt(e);if (typ=='DEST' ){jumpDest(u)}else{  showdetail('nw',typ,u) }}
function setDetail(c,h){c="<div id=ajTop2></div>"+c;pnlCnt.innerHTML=c;if (isMoz()){pnlCnt.style.height= h + 'px';}else{pnlCnt.style.height= h;}}
function showdetail(r, t, u) {
    _cnEvt();
    mShowModalWin('HotelQuickView', 'aj', u, 550, 720, 10, true, false, 'HotelQuickView', true)

}	

function showAJAXPop(bhv,evt){$find(bhv).show(); _cnEvt(evt);}
function hideAJAXPop(bhv){$find(bhv).hide()}


function mEnablePage(){}

function mDisablePage() {
    var width = document.documentElement.clientWidth + document.documentElement.scrollLeft;
    var height = document.documentElement.clientHeight + document.documentElement.scrollTop;

    var layer = document.createElement('div');
    layer.style.zIndex = 2;
    layer.id = 'layer';
    layer.style.position = 'absolute';
    layer.style.top = '0px';
    layer.style.left = '0px';
    layer.style.height = document.documentElement.scrollHeight + 'px';
    layer.style.width = width + 'px';
    layer.style.backgroundColor = 'gray';
    layer.style.opacity = '.6';
    layer.style.filter += ("progid:DXImageTransform.Microsoft.Alpha(opacity=60)");
    document.body.style.position = 'static';
    document.body.appendChild(layer);  
}

function hideModal(n){ if (document.getElementById('layer')){document.body.removeChild( document.getElementById('layer'))};document.body.style.position = '';if (document.getElementById(n)) { document.body.removeChild(document.getElementById(n)) } }
function mShowModalWin(name,id,src,h,w,t,trn,cntr,type,bHeight) {
    _cnEvt();

try{
    var width = document.documentElement.clientWidth + document.documentElement.scrollLeft;
    var height = document.documentElement.clientHeight + document.documentElement.scrollTop;
   mDisablePage()
    var size = { 'height':h, 'width': w };
    var i = document.createElement('iframe');
    i.name = name;
    i.id = id;
    if (size.height>0 && bHeight){src=appndURL(src,"h=" + size.height)}
    i.src = '/ifrblank.htm'// no white    
    i.scrolling='no';
    i.style.height = size.height + 'px';
    i.style.width = size.width + 'px';
    t=(document.documentElement.scrollTop-20)+t;
    i.style.position = 'absolute';
    i.style.zIndex = 3000;
    if (trn){i.allowTransparency=true}
    else{
      i.style.backgroundColor = 'white';
      i.style.border = '2px solid silver';
    }
    i.frameBorder = 'no';	
   
    if (cntr){i.style.top = '100px'}else{    
    i.style.top = t + 'px'}
    i.style.left = (width / 2) - (size.width / 2) + 'px';		
    document.body.appendChild(i); 
    i.src = src;    
   // myTrackEvent('Popup','ShowPopup',name, '')
} catch (e) {
alert(e.description)
}
}

// **************  END AJAX POPUP ********************************************************
function isDate(dateStr) {
    var datePat = /^(\d{1,2})(\/|-)(\d{1,2})(\/|-)(\d{4})$/;
    var matchArray = dateStr.match(datePat); // is the format ok?
    return matchArray != null
}
function isTime(timeStr) {
    var datePat = /^\d{1,2}:\d{2}([ap]m)?$/;
    var matchArray = timeStr.match(datePat); // is the format ok?
    return matchArray != null
}
function DateAdd(timeU, byMany, dateObj) {
    var millisecond = 1;
    var second = millisecond * 1000;
    var minute = second * 60;
    var hour = minute * 60;
    var day = hour * 24;
    var year = day * 365;

    var newDate;
    var dVal = dateObj.valueOf();
    switch (timeU) {
        case "ms": newDate = new Date(dVal + millisecond * byMany); break;
		case "s": newDate=new Date(dVal+second*byMany); break;
		case "mi": newDate=new Date(dVal+minute*byMany); break;
		case "h": newDate=new Date(dVal+hour*byMany); break;
		case "d": newDate=new Date(dVal+day*byMany); break;
		case "y": newDate=new Date(dVal+year*byMany); break;
	}
	return newDate;
}
function AND(a, b) {
    var result = 0;
    var x = binaryArray(parseInt(a));
    var y = binaryArray(parseInt(b));
    var biggerArray = (x.length >= y.length) ? x : y;
    var smallerArray = (biggerArray == x) ? y : x;
    var len = biggerArray.length;
    for (var i = 0; i < len; i++) {
        biggerArray[i] = (biggerArray[i] & smallerArray[i]) ? 1 : 0;
        result += biggerArray[i] * Math.pow(2, i);
    }
    return result;
}
function binaryArray(num) {
    var arr = new Array();
    var div;
    var mod;
    var n = num;
    var count = 0;
    do {
        mod = n % 2;
        n = parseInt(n / 2);
        arr[count++] = mod;
    } while (n > 0)
    return arr;
}

function closeme() { $.fancybox.close(); }
function isScrolledIntoView(elem) { var docViewTop = $(window).scrollTop(); var docViewBottom = docViewTop + $(window).height(); var elemTop = $(elem).offset().top; var elemBottom = elemTop + $(elem).height(); return ((elemBottom >= docViewTop) && (elemTop <= docViewBottom) && (elemBottom <= docViewBottom) && (elemTop >= docViewTop)); }

function isScrolledIntoView2(id) {       
    var boundingRef = document.querySelectorAll(id)[0].getBoundingClientRect();  
    if (boundingRef.top<75){ return false;}                                                 
    return true;
}


var isInViewport2 = function (elem) {
    var bounding = elem.getBoundingClientRect();
    var nHeight=window.innerHeight || document.documentElement.clientHeight;
    return (
        (bounding.top >= 70 && bounding.top<=nHeight) ||
         (bounding.bottom >= 70 && bounding.bottom<=nHeight)    ||
          (bounding.top <= 70   && bounding.bottom>nHeight )
    );
};

function findMostInView(elements) {
    var mostInViewElement = null;
    var highestVisibility = 0;

    elements.forEach(function(element) {
      var visibility = calculateVisibility(element);

      if (visibility > highestVisibility) {
        highestVisibility = visibility;
        mostInViewElement = element;
      }
    });

    return mostInViewElement;
  }

  // Function to calculate visibility percentage of an element
  function calculateVisibility(element) {
    var rect = element.getBoundingClientRect();
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    var visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

    return (visibleHeight / rect.height) * 100;
  }



function validateEmail(email) { var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\ ".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA -Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; return re.test(email); }

function getreturl() { if (typeof returl == "undefined") { return ""; } else { return returl; } }

function isiniframe() { return ((window.location != window.parent.location) ? true : false); }

$.fn.isInViewport = function () {


    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};


function setCookie(cookieName, cookieValue, nDays) {
    var today = new Date(),
        expire = new Date();

    if (nDays === null || nDays === 0) {
        nDays = 1;
    }

    expire.setTime(today.getTime() + 3600000 * 24 * nDays);

    document.cookie = cookieName + "=" + escape(cookieValue) + ";expires=" + expire.toGMTString();
};

function getCookie(cookieName) {
    var theCookie = " " + document.cookie,
        ind = theCookie.indexOf(" " + cookieName + "=");

    if (ind === -1) { ind = theCookie.indexOf(";" + cookieName + "="); }
    if (ind === -1 || cookieName === "") { return ""; }

    var ind1 = theCookie.indexOf(";", ind + 1);

    if (ind1 === -1) { ind1 = theCookie.length; }

    return unescape(theCookie.substring(ind + cookieName.length + 2, ind1));
};

function pushLoadMore(url, p) {
    var title = document.title;
    if (p != undefined && p != "" && p != "1") { if (title.indexOf("| Page ") > 0) { title = title.substring(0, title.indexOf("| Page ")) + "| Page " + p; } else { title += " | Page " + p; } }
    var stateObj = { Title: title };
    history.pushState(stateObj, title, url);
    document.title = title;
}


 function element_Blur(selector,blur) {
    if (blur) {
          $(selector).css({ opacity: 0.3 })
    } else {
        $(selector).css('opacity', '');
    }
}

function Page_Blur(blur) {
    element_Blur('body',blur);
}

jQuery(document).ready(function ($) {
})